import { useContext } from 'react';
import classes from './CompanyInfo.module.css';
import { ThemeContext } from '../../App';
import buildingPicture from './FiDi photo.jpg';
import { getParticleColor } from '../../utils/particles';

export default function CompanyInfo() {
  const { theme } = useContext(ThemeContext);

  return (
    <div id={classes[theme]} className={classes.container}>
      <div className={classes.imageBlock}>
        <img src={buildingPicture} alt="building" />
      </div>
      <div className={classes.infoSide}>
        <div
          style={{
            borderLeft: `7px solid ${getParticleColor().trim()}`,
            paddingLeft: '16px',
          }}
        >
          <h3
            className="text-lgBigSepTxt md:text-mdBigSepTxt lg:text-lgBigSepTxt text-center"
            style={{
              display: 'inline-block',
              color: getParticleColor().trim(),
              fontWeight: 600,
            }}
          >
            10+
          </h3>
          <br />
          <h5
            className="text-smSepBtnTxt md:text-mdBtwPages lg:text-lgSepBtnTxt text-center"
            style={{ textTransform: 'uppercase', display: 'inline-block' }}
          >
            years of experience
          </h5>
        </div>

        <p className="text-smAdd2Txt md:text-mdTitlesForH lg:text-lgSepBtn2Txt lg:block">
          FP Technologies was founded by a visionary group of IT professionals
          who saw a need in the industry to deliver extraordinary results
          through innovation. Driven by this mission, the company experienced
          remarkable double digit growth year after year. We have consistently
          empowered teams with bespoke, scalable solutions that have not only
          fueled client success but also catalyzed their expansion across
          multiple domains.
          <br /> We are honored to have fostered enduring, trust-based
          relationships with our clients and will continue to find innovative
          ways to deliver unparalleled value to all stakeholders.
        </p>
      </div>
    </div>
  );
}
